import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import AtosService from '../../../../../services/ato-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';






const Ato = () => {
    let { id } = useParams()

    const [numAto, setNumAto] = useState("");
    const [dataAto, setDataAto] = useState("");
    const [categoria, setCategoria] = useState("");
    const [descricao, setDescricao] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchAto(id) {
        const response = await AtosService.atoEdit(id);
        Moment.locale();
        setNumAto(response.data["numAto"]);
        setDataAto(Moment(response.data["dataAto"]).utc(false).format("yyyy-MM-DD"));
        setDescricao(response.data["descricao"]);
        setCategoria(response.data["categoria"]);
    }

    useEffect(() => {
        fetchAto(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const ato = await AtosService.editar(id, {
                numAto: numAto,
                dataAto: dataAto,
                categoria: categoria,
                descricao: descricao
            })
            if (ato.data["numAto"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="numAto">
                                <FloatingLabel
                                    label="Número do Ato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="numAto"
                                        value={numAto}
                                        onChange={e => setNumAto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataAto">
                                <FloatingLabel
                                    label="Data do Ato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataAto"
                                        value={dataAto}
                                        onChange={e => setDataAto(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option value={categoria}>{categoria}</option>
                                        <option value="Despacho">Despacho</option>
                                        <option value="Ofício">Ofício</option>
                                        <option value="Memorando">Memorando</option>
                                        <option value="Processo Administrativo">Processo Administrativo</option>
                                        <option value="Ofício Circular">Ofício Circular</option>
                                        <option value="Despacho de Encaminhamento">Despacho de Encaminhamento</option>
                                        <option value="Decisão">Decisão</option>
                                        <option value="Decreto">Decreto</option>
                                        <option value="Instrução Normativa">Instrução Normativa</option>
                                        <option value="Ato Administrativo Não Especificado">Ato Administrativo Não Especificado</option>
                                        <option value="Lei Ordinária">Lei Ordinária</option>
                                        <option value="Lei Complementar">Lei Complementar</option>
                                        <option value="Laudo">Laudo</option>
                                        <option value="Laudo Pericial">Laudo Pericial</option>
                                        <option value="Íntegra de Processo Administrativo">Íntegra de Processo Administrativo</option>
                                        <option value="Ações de Governo">Ações de Governo</option>
                                        <option value="Decisão Judicial">Decisão Judicial</option>
                                        <option value="Processo Judicial">Processo Judicial</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="Descrição">
                                <FloatingLabel
                                    label="Descrição"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="textarea"
                                        name="descricao"
                                        value={descricao}
                                        onChange={e => setDescricao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/atos/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Ato editado com sucesso!</Alert>
                <Navigate to={'/restrito/atos/listar'} />
            </Fragment>
        )
    }
}

export default Ato;